import { render, staticRenderFns } from "./ProjectReportingDashboard.vue?vue&type=template&id=628d52b3&scoped=true&"
import script from "./ProjectReportingDashboard.vue?vue&type=script&lang=js&"
export * from "./ProjectReportingDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectReportingDashboard.vue?vue&type=style&index=0&id=628d52b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628d52b3",
  null
  
)

export default component.exports